<script setup>
// The number over each chart of a report (7-2 = A: a tile over its chart, in pairs): the summary value of the
// metric and its change against the previous period, as the kit's tile. Times going up is bad (lowerIsBetter).
// Not measured (a time with no conversations) is "-" (7-10); a failed summary says so under the dash.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useReportMetrics } from 'dashboard/composables/useReportMetrics';
import { STATUS } from 'dashboard/store/constants';
import ReportStatTile from 'dashboard/components-next/polaris/reports/ReportStatTile.vue';

const props = defineProps({
  metric: {
    type: Object,
    default: () => ({}),
  },
  accountSummaryKey: {
    type: String,
    default: 'getAccountSummary',
  },
  summaryFetchingKey: {
    type: String,
    default: 'getAccountSummaryFetchingStatus',
  },
});

const { t } = useI18n();

const { calculateTrend, displayMetric, isAverageMetricType, fetchingStatus } =
  useReportMetrics(props.accountSummaryKey, props.summaryFetchingKey);

const finished = computed(() => fetchingStatus.value === STATUS.FINISHED);
const value = computed(() =>
  finished.value ? displayMetric(props.metric.KEY) || '-' : '-'
);
</script>

<template>
  <ReportStatTile
    :label="metric.NAME"
    :value="value"
    :loading="fetchingStatus === STATUS.FETCHING"
    :hint="
      fetchingStatus === STATUS.FAILED
        ? t('REPORT.SUMMARY_FETCHING_FAILED')
        : ''
    "
    :trend="finished ? calculateTrend(metric.KEY) : 0"
    :lower-is-better="isAverageMetricType(metric.KEY)"
  />
</template>
